import { render, staticRenderFns } from "./JudicialLiquidation.vue?vue&type=template&id=99a6c4d6&scoped=true&"
import script from "./JudicialLiquidation.vue?vue&type=script&lang=js&"
export * from "./JudicialLiquidation.vue?vue&type=script&lang=js&"
import style0 from "./JudicialLiquidation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./JudicialLiquidation.vue?vue&type=style&index=1&id=99a6c4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a6c4d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
